import CountUp from './index.vue'

CountUp.install = Vue => {
  Vue.component(CountUp.name, CountUp)
}

export default CountUp



// WEBPACK FOOTER //
// ./src/components/count/index.js